import { render, staticRenderFns } from "./PDFs.vue?vue&type=template&id=3cba249a&scoped=true"
var script = {}
import style0 from "./PDFs.vue?vue&type=style&index=0&id=3cba249a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cba249a",
  null
  
)

export default component.exports